import { jsx as _jsx } from "react/jsx-runtime";
import { DataGrid, Skeleton } from '@emburse/embark-core';
function SkeletonDataGrid({ skeletonRows, loading, columns, rows, ...dataGridProps }) {
    const loadingDataGridProps = {
        ...dataGridProps,
        columns: columns.map((column) => ({
            ...column,
            renderCell: () => _jsx(Skeleton, { animation: "pulse", sx: { width: '100%' } })
        })),
        rows: Array(skeletonRows)
            .fill({})
            .map((row, i) => ({ ...row, id: i })),
        pageSizeOptions: [skeletonRows],
        loading: false,
        hideFooter: true
    };
    return (_jsx(DataGrid, { ...(loading
            ? loadingDataGridProps
            : {
                ...dataGridProps,
                columns: columns.map((column) => ({
                    ...column,
                    renderCell: column.renderCell
                })),
                rows
            }) }));
}
SkeletonDataGrid.defaultProps = {
    skeletonRows: 5
};
export default SkeletonDataGrid;
